import * as React from 'react';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import { __t, applyTranslations } from 'utils/language';
import { SENTIMENT_CLASS_COLORS } from 'utils/sentiment';

import './sentiment-select.scss';

applyTranslations(require('./sentiment-select.i18n.json'));

import type { SentimentClass } from 'types';

import type { SyntheticEvent } from 'react';

type Props = {
  value: SentimentClass,
  onChange?: (a: SentimentClass) => void
};

class SentimentSelect extends React.PureComponent<Props> {
  handleChange = (event: SyntheticEvent<HTMLElement>) => {
    const { value, onChange } = this.props;
    const target = event.currentTarget;
    // TS is not getting sentimentClass will be one of SENTIMENT_CLASS_COLORS
    const sentimentClass = target.dataset.sentimentClass as SentimentClass;

    if (value !== sentimentClass && onChange) {
      onChange(sentimentClass);
    }
  };

  render() {
    const { value, onChange } = this.props;

    return (
      <section className="sentiment-select">
        {
          Object.keys(SENTIMENT_CLASS_COLORS).map(sentimentClass => (
            <div
              key={`sentiment-class-${sentimentClass}`}
              title={__t(`sentiment_select.${sentimentClass}`)}
              className="sentiment-select__item"
              data-sentiment-class={sentimentClass}
              onClick={this.handleChange}
            >
              <SVGDynamicIcon
                name={`emoji-${sentimentClass}-custom-fg`}
                width={32}
                height={32}
                clickable={value !== sentimentClass && Boolean(onChange)}
                customColor={value === sentimentClass ? SENTIMENT_CLASS_COLORS[sentimentClass] : 'grey-light'}
              />
            </div>
          ))
        }
      </section>
    );
  }
}

export default SentimentSelect;
